function AlcoholVideoCommand() {
    "use strict";

    this.__type = 'AlcoholVideoCommand:www.veritracks.com';
    this.Id = -1;
    this.EnrolleeId = null;
    this.EnrolleeTimeZone = '';
}
if (typeof exports !== 'undefined') {
    module.exports = AlcoholVideoCommand;
}